<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <span class="msg" [innerHTML]="alert.message">
    
    </span>
    <button class="alert-close" type="button" title="remove alert"   (click)="removeAlert(alert)">
        <mat-icon>close</mat-icon></button>
</div>
